import { useAppSelector } from 'app/hooks';
import {
  selectIsUserAgent,
  selectUserFeatures,
} from 'services/session/sessionSelectors';
import {
  SERVICE_ENTITLEMENTS_MAPPING,
  SERVICES,
} from 'utils/service-entitlements-config';
import type { ServicesType } from 'utils/globalTypes';

function useIsFeatureAvailable(
  service: ServicesType,
  agentCheckRequired = true,
) {
  const userFeatures = useAppSelector(selectUserFeatures);
  const isAgent = useAppSelector(selectIsUserAgent);

  return (
    SERVICE_ENTITLEMENTS_MAPPING[service]?.some((entitlement) => {
      if (
        isAgent &&
        agentCheckRequired &&
        SERVICE_ENTITLEMENTS_MAPPING[SERVICES.digitalVault].includes(
          entitlement,
        )
      ) {
        return false;
      }

      return userFeatures.includes(entitlement);
    }) ?? false
  );
}

export default useIsFeatureAvailable;
